package core.dateformat.ui

sealed interface DateTimeEvent {
    data object GetInitialDateFormat : DateTimeEvent
    data class ChangeDateFormat(val dateFormat: String) : DateTimeEvent
}